import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-transparent',
  templateUrl: './loading-transparent.component.html',
  styleUrls: ['./loading-transparent.component.scss']
})
export class LoadingTransparentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
